import {
  useInfiniteQuery,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
} from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { principalCandidatesListQueries } from 'queryKeys/principal';
import {
  CandidatesListOrdering,
  PrincipalCandidatesListResponse,
} from 'features/Principal/types/candidatesListTypes';
import principalsAPI from 'api/principalsAPI';

export const useInfiniteQueryGetPrincipalCandidatesList = (
  schoolId: number | string,
  ordering?: CandidatesListOrdering,
  options?: Omit<
    UseInfiniteQueryOptions<PrincipalCandidatesListResponse, AxiosError>,
    'queryKey' | 'queryFn'
  >
): UseInfiniteQueryResult<PrincipalCandidatesListResponse, AxiosError> => {
  const numberSchoolId = Number(schoolId);
  const enabled = schoolId != null && !Number.isNaN(numberSchoolId);

  return useInfiniteQuery({
    queryKey: principalCandidatesListQueries.list({
      schoolId: numberSchoolId,
      ordering,
    }).queryKey,
    queryFn: ({ pageParam = 1 }) => {
      const pageInt = Number(pageParam);

      return principalsAPI.getCandidatesList({
        school_id: numberSchoolId,
        page: pageInt,
        ordering,
      });
    },
    getNextPageParam: (lastPage) => {
      if (!lastPage.next) return undefined;
      const nextPage = new URL(lastPage.next).searchParams.get('page');
      return nextPage ?? undefined;
    },
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    enabled,
    ...options,
  });
};
